module.exports = __webpack_public_path__ + "img/germany-infectious-diseases-female.07a26b60.png";